import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client/react";
import { gql } from "../../__generated__";
import { useRequiredParams } from "shared/src/hooks/use-required-params";
import PathConstants from "../../routes/path-constants";

export const PAYMENT_GATE_QUERY = gql(`
  query PaymentGate($appealId: ID!) {
    appealStatus(appealId: $appealId) {
      paymentSuccessful
    }
  }
`);

export function PaymentGate() {
  const { appealId } = useRequiredParams<"appealId">();
  const navigate = useNavigate();

  const { loading, data } = useQuery(PAYMENT_GATE_QUERY, {
    variables: { appealId },
    fetchPolicy: "no-cache",
  });

  const paymentSuccessful = data?.appealStatus?.paymentSuccessful;

  const readyToSubmitPath =
    PathConstants.MyAppealsFinalizeReadyToSubmit.replace(":appealId", appealId);

  useEffect(() => {
    if (paymentSuccessful) {
      navigate(readyToSubmitPath, { replace: true });
    }
  }, [paymentSuccessful, readyToSubmitPath, navigate]);

  if (loading) return null;

  return <Outlet />;
}
